(() => {
  const normalize = value => String(value || '').normalize('NFKC').toLowerCase()
    .replace(/[\u30a1-\u30f6]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x60))
    .replace(/[\s・ー_\-]/g, '');
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-grid]');
    const input = root.querySelector('input');
    const filters = root.querySelector('[data-filters]');
    const status = root.querySelector('[data-status]');
    const pagination = root.querySelector('[data-pagination]');
    const loadStatus = root.querySelector('[data-load-status]');
    const retry = root.querySelector('[data-retry]');
    let cards = [], category = '', loading = false, complete = false;
    let next = pagination.querySelector('[data-next]')?.getAttribute('href');
    const priorPage = pagination.querySelector('[data-previous]')?.getAttribute('href');
    // Start from page one even when a customer arrives on a paginated URL.
    let restart = Boolean(priorPage);
    const seenPages = new Set();
    const number = v => Number.isFinite(Number(v)) ? Number(v) : 9999;
    function refresh() {
      cards = [...grid.querySelectorAll('[data-card]')];
      cards.sort((a,b) => number(a.dataset.categoryOrder)-number(b.dataset.categoryOrder)
        || a.dataset.category.localeCompare(b.dataset.category)
        || number(a.dataset.order)-number(b.dataset.order)
        || a.dataset.name.localeCompare(b.dataset.name, 'ja'));
      cards.forEach(card => grid.append(card));
      const active = document.activeElement?.closest('[data-category-button]')?.dataset.categoryButton;
      const groups = new Map();
      cards.forEach(card => { if (!groups.has(card.dataset.category)) groups.set(card.dataset.category, card.dataset.categoryLabel); });
      filters.replaceChildren();
      [['','すべて'], ...groups].forEach(([key,label]) => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = label;
        button.dataset.categoryButton = key;
        button.addEventListener('click', () => { category = key; filter(); });
        filters.append(button);
      });
      if (active !== undefined) [...filters.children].find(b => b.dataset.categoryButton === active)?.focus();
      filter();
    }
    function filter() {
      const query = normalize(input.value);
      let count = 0;
      cards.forEach(card => {
        const matches = (!category || card.dataset.category === category) && normalize(card.dataset.search).includes(query);
        card.hidden = !matches; if(matches) count++;
      });
      [...filters.children].forEach(b => b.setAttribute('aria-pressed', String(b.dataset.categoryButton === category)));
      status.textContent = `${count}件の製品${complete ? '' : '（読み込み済みの製品）'}`;
      root.querySelector('[data-empty]').hidden = count > 0 || !complete;
    }
    async function loadAll() {
      if (loading) return;
      loading = true; retry.hidden = true; complete = false;
      root.setAttribute('aria-busy', 'true');
      loadStatus.hidden = false; loadStatus.textContent = '製品情報を読み込んでいます…';
      try {
        if (restart) {
          const start = new URL(location.href); [...start.searchParams.keys()].filter(k => /^page(?:_|$)/.test(k)).forEach(k => start.searchParams.delete(k));
          next = start.href;
        }
        while(next) {
          const url = new URL(next, location.href);
          if (url.origin !== location.origin || seenPages.has(url.href)) throw new Error('Invalid pagination');
          const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
          if (!response.ok) throw new Error('Load failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = [...doc.querySelectorAll('[data-np-support]')].find(s => s.dataset.sectionId === root.dataset.sectionId);
          if (!section || !section.querySelector('[data-grid]')) throw new Error('Missing section');
          if (restart) { grid.replaceChildren(); restart = false; }
          const keys = new Set([...grid.querySelectorAll('[data-card]')].map(c => c.dataset.key));
          section.querySelectorAll('[data-card]').forEach(card => { if(!keys.has(card.dataset.key)) { grid.append(document.importNode(card, true)); keys.add(card.dataset.key); } });
          seenPages.add(url.href);
          next = section.querySelector('[data-next]')?.getAttribute('href');
          refresh();
        }
        complete = true; pagination.hidden = true; loadStatus.hidden = true;
      } catch(error) {
        // Keep native pagination usable if a later batch fails.
        loadStatus.textContent = '一部の製品を読み込めませんでした。再読み込みするか、ページ送りからお探しください。';
        pagination.hidden = false; retry.hidden = false;
      } finally {
        loading = false; root.setAttribute('aria-busy', 'false'); filter();
      }
    }
    input.addEventListener('input', filter);
    root.querySelector('[data-reset]').addEventListener('click', () => { input.value = ''; category = ''; filter(); });
    retry.addEventListener('click', loadAll);
    root.querySelectorAll('[data-controls]').forEach(el => el.hidden = false);
    refresh(); loadAll();
  }
  function scan(scope = document) { scope.querySelectorAll('[data-np-support]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
